export default __webpack_public_path__ + "s9.png";